export default "__VITE_ASSET__BccMvhIQ__"